import {
    DisplayedCarInfoInterface,
    isReserveHomeAllowed,
    isReserveHubAllowed, isSeeDealer0Allowed,
    isSeeHomeAllowed,
    isSeeHubAllowed,
} from '@/types';
import { AvailableCTAs } from './CarCTAs.enum';

export const getRequiredCTAs = (
    carInfo: DisplayedCarInfoInterface,
    showFinancingButton: boolean
) => {
    const isReserveAllowed = !!(
        carInfo?.bookingType &&
        (isReserveHubAllowed(carInfo.bookingType) ||
            isReserveHomeAllowed(carInfo.bookingType)) &&
        !carInfo.isReserved
    );
    const isSeeAllowed = !!(
        carInfo?.bookingType &&
        carInfo.id &&
        (isSeeHomeAllowed(carInfo?.bookingType) ||
            isSeeHubAllowed(carInfo?.bookingType) ||
            isSeeDealer0Allowed(carInfo?.bookingType)
        )
    );
    const isFinancingAllowed = !!(
        showFinancingButton &&
        !carInfo.isReserved &&
        !carInfo.isSold &&
        !carInfo.isPurchaseInProgress &&
        (((isSeeHomeAllowed(carInfo?.bookingType) ||
            isSeeHubAllowed(carInfo?.bookingType) ||
                    isSeeDealer0Allowed(carInfo?.bookingType)) &&
            !(
                isReserveHubAllowed(carInfo?.bookingType) ||
                isReserveHomeAllowed(carInfo?.bookingType)
            )) ||
            (!(
                isSeeHomeAllowed(carInfo?.bookingType) ||
                isSeeHubAllowed(carInfo?.bookingType) ||
                isSeeDealer0Allowed(carInfo?.bookingType)
            ) &&
                (isReserveHubAllowed(carInfo?.bookingType) ||
                    isReserveHomeAllowed(carInfo?.bookingType))))
    );
    // { ACTION FLAG }

    const isNotifyMeAllowed = !!(carInfo?.isReserved && carInfo?.id);

    //PUSHING ACTIONS IN ORDER
    const ctaConfig: { key: AvailableCTAs; condition: boolean }[] = [
        { key: AvailableCTAs.NOTIFY_ME, condition: isNotifyMeAllowed },
        { key: AvailableCTAs.RESERVE, condition: isReserveAllowed },
        { key: AvailableCTAs.BOOKING, condition: isSeeAllowed },
        { key: AvailableCTAs.FINANCING, condition: isFinancingAllowed },
        // { COMPONENT KEY : ACTION FLAG }
    ];

    const requiredCTAs: AvailableCTAs[] = ctaConfig
        .filter(({ condition }) => condition)
        .map(({ key }) => key);

    return requiredCTAs;
};
